module.exports = __webpack_public_path__ + "img/product-brakedisk-modal.5944b47f.png";